import qs from 'qs';
import client from '@/api/base';

export default {
  async coachValidateCancellation(meetingId, data) {
    const response = await client.patch(`coaching/schedule/cancellation/${meetingId}/`, data);
    return response;
  },

  // Coach calendar
  async getCoachCalendar(params) {
    const response = await client.get(`coaching/schedule/calendar/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async getCoachRecurringAvailabilities() {
    const response = await client.get('coaching/schedule/');
    return response;
  },

  async saveCoachRecurringAvailabilities(data) {
    const response = await client.put('coaching/schedule/', data);
    return response;
  },

  async getCoachCalendarExceptions(params) {
    const response = await client.get(`coaching/schedule/calendar/exception-date/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async saveCoachCalendarException(data) {
    const response = await client.patch('coaching/schedule/calendar/exception-date/', data);
    return response;
  },

  async importCalendarAvailability() {
    const response = await client.post('coaching/schedule/calendar/sync/');
    return response;
  },

  // Leader attendance
  async leaderDoesAttendance(id) {
    const response = await client.patch(`events/schedule/${id}/attendance/`);
    return response;
  },

  async leaderDoesNotAttendance(id, data) {
    const response = await client.post(`events/schedule/${id}/attendance/`, data);
    return response;
  },
};
